/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { openModalWithContent } from '../../utils/modal-helpers';
window.TechnicalEvalutionTableClass = require('./evaluation_tables/technical_evaluation_table');

window.Bids = {
  initializeAnalysisGraph() {
    $(".days-left, #bid-progress-fluid").hide();
    const total_hrs = $("#total_hrs").html();
    const hrs_left = $("#hrs_left").html();
    const item = $("#bid-ruler");
    for (let i = 0; i <= 4; i++) {
      var last;
      if (i === 4) { last = 'margin-left:-30px'; }
      item.append("<b style='left:" + (25 * i) + "%;" + last + "'>" + (25 * i) + "%</b>");
    }
    $('#bid-progress-fluid').css('width', total_hrs + '%');
    return $(".days-left, #bid-progress-fluid").show();
  },

  showModalWithContent(modal, content) {
    const modalId = modal.replace('#', '');
    return openModalWithContent(modalId, content);
  },

  tabChanger() {
    const sectionID = window.location.href.split('#')[1];
    if ((sectionID === 'technical') || (sectionID === 'commercial')) {
      $('#tabs .tab-title.active').removeClass('active').attr('aria-selected', false);
      $('#tabs .content.active').removeClass('active').attr('aria-hidden', true);
      $(`#tabs a[href^='#${sectionID}']`).parent().addClass('active').attr('aria-selected', true);
      return $(`#tabs .content[id^='${sectionID}']`).addClass('active').attr('aria-hidden', false);
    }

    $(document).on('click', '.tab_header', function (e) {
      $('.tab_container').hide();
      return $("#" + $(e.currentTarget).data('show-tab')).show();
    });
    return $(document).on('click', 'a[href="#commercial_container"]', e => {
      return this._rerenderFinanceTable();
    });
  },

  _rerenderFinanceTable() {
    const isFinanceTableSubTabActive = !$('#financials-table').hasClass('hidden');

    if (isFinanceTableSubTabActive && DocumentsFinance.rerenderTable) {
      DocumentsFinance.refreshTableData('financeGrid');
      return DocumentsFinance.rerenderTable = false;
    }
  },

  initializeFinanceSubTabs() {
    return $('#financials-chart-table-switch a').on('click', function (event) {
      event.preventDefault();
      const $target = $(event.currentTarget);
      $target.addClass('active');
      $target.siblings().removeClass('active');

      const otherContainerId = $target.siblings().attr('href');
      $(otherContainerId).addClass('hidden');

      const containerId = $target.attr('href');
      $(containerId).removeClass('hidden');
      $('#financials-table-export').toggleClass('hidden', !$target.is("[href='#financials-table']"));
      $('#financials-chart-actions').toggleClass('hidden', $target.is("[href='#financials-table']"));
      if ((containerId === '#financials-table') && (DocumentsFinance.biddersChanged || $("#includeRevokedBids").prop("checked"))) {
        DocumentsFinance.refreshTableData('financeGrid');
        return DocumentsFinance.rerenderTable = false;
      }
    });
  },
  selectRevokedBids() {
    return $("#includeRevokedBids").on('change', function () {
      const isChecked = $("#includeRevokedBids").prop("checked");
      const $revokedBids = $("#biddersList .item.revoked");
      $revokedBids.find("input:checkbox").prop("checked", isChecked).trigger('change');
      return $revokedBids.toggleClass('hidden');
    });
  },

  manageBidsExportLink() {
    $(document).on('click', '#export_bids_summary_link', function (e) {
      e.preventDefault(); // stop default navigation to include include_revoked_bids param

      var $link = $('#export_bids_summary_link');
      var baseHref = $link.data('base-href');
      if (!baseHref) {
        baseHref = $link.attr('href');
        $link.data('base-href', baseHref);
      }

      var href = baseHref;

      if ($("#includeRevokedBids").prop("checked")) {
        href += (href.indexOf('?') > -1 ? '&' : '?') + 'include_revoked_bids=true';
      } else {
        href = href.replace(/([?&])include_revoked_bids=true(&)?/, function (match, p1, p2) {
          return p2 ? p1 : '';
        }).replace(/[?&]$/, '');
      }

      window.location.href = href;
    });
  },

  initializeTenderPostingDropdown() {
    return $(document).on('click', '.tender-posting-item', function (event) {
      const $selected = $(event.currentTarget);
      const tenderPostingId = $selected.data('id');
      const $target = $('#tenderPostings-drop');
      $target.find('a').removeClass('selected');
      $target.find('a[data-id="' + tenderPostingId + '"]').addClass('selected');
      return $target.parent().find('span').text($selected.html()).data($selected.data());
    });
  }
};
